import React, { Suspense } from 'react'

import { MainTabsV2 } from '@labrav/react-components'
import { settingsTabs } from '../FlyOutOnboardingWrapper/settingsTabs'
import { Route, Routes } from 'react-router-dom'
import { useStyles } from './FlyOutStorefrontV2.styles'
import { Storefront } from './Storefront/Storefront'
import { STOREFRONT_TAB } from './constants'
import { FlyoutStorefrontMetrics } from '../FlyoutStorefrontMetrics/FlyoutStorefrontMetrics'

export const FlyOutStorefrontV2 = () => {
  const { classes } = useStyles()

  const defaultTabs = [
    {
      key: STOREFRONT_TAB.BUILDER.key,
      label: STOREFRONT_TAB.BUILDER.label,
      path: STOREFRONT_TAB.BUILDER.path,
      renderElement: (
        <div data-testid={'storefront-content'}>
          <Storefront />
        </div>
      ),
    },
    {
      key: STOREFRONT_TAB.ANALYTICS.key,
      label: STOREFRONT_TAB.ANALYTICS.label,
      path: STOREFRONT_TAB.ANALYTICS.path,
      renderElement: (
        <div data-testid={'storefront-metrics-content'}>
          <FlyoutStorefrontMetrics />
        </div>
      ),
    },
  ]

  const {
    defaultSettingsTabs,
    activeTab,
    handleTabChange,
    settingsTabsForRouting,
  } = settingsTabs([], defaultTabs, true)

  return (
    <div className={classes.root} style={{}}>
      <div className={classes.tabContainer}>
        <div className={classes.wrapper}>
          <MainTabsV2
            tabs={defaultSettingsTabs}
            activeTabIndex={activeTab}
            onChange={handleTabChange}
            tabsType={'main'}
          />
        </div>
      </div>
      <div className={classes.content}>
        <Suspense fallback={<div />}>
          <Routes>
            {settingsTabsForRouting.map(t => {
              return (
                <Route
                  key={t.path}
                  path={t.path}
                  element={t.renderElement ? t.renderElement : <></>}
                />
              )
            })}
          </Routes>
        </Suspense>
      </div>
    </div>
  )
}
